export const REDIRECT_PARAM_NAME = 'redirectTo';